import React, { FC } from 'react';

import { Body } from '../../TypographyNew';
import styled from 'styled-components';

const LegendBall = styled.span`
  width: var(--spacing-s);
  height: var(--spacing-s);
  background: ${(p) => p.color};
  border-radius: var(--radius-100);
`;

const LegendItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-s);
`;

export const Legends = styled.div`
  display: flex;
  gap: var(--spacing-m);
`;

type LegendsProps = {
  color: string;
};

export const LegendItem: FC<LegendsProps> = ({ color, children }) => {
  return (
    <LegendItemContainer>
      <LegendBall color={color} />
      <Body variant={2}>{children}</Body>
    </LegendItemContainer>
  );
};
